"use client";
import { DropdownMenu } from "radix-ui";
import React from "react";
import type { MenuRadioGroupProps } from "./interface";
import css from "./styles.module.css";

/** @ignore */
export const MenuRadioGroup = React.forwardRef<HTMLDivElement, MenuRadioGroupProps>(({ children, ...props }, ref) => {
  return (
    <DropdownMenu.RadioGroup {...props} data-quipu="MenuRadioGroup" className={css.root} ref={ref}>
      {children}
    </DropdownMenu.RadioGroup>
  );
});

MenuRadioGroup.displayName = "MenuCheckboxItem";
